module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-300-[118]117.64208c9.woff2";